<template>
    <custom-avatar circle :pointer="pointer" :size="size">
        <img
            v-if="pictureUrl"
            :src="pictureUrl"
            alt="Usuario"
            class="w-full h-full object-cover"
            referrerpolicy="no-referrer"
        />
        <span v-else class="font-bold text-white" :class="textSizeClass">
            {{ initial }}
        </span>
    </custom-avatar>
</template>

<script>
import CustomAvatar from "@/components/utils/CustomAvatar.vue";

export default {
    name: "UserAvatar",

    components: { CustomAvatar },

    props: {
        pictureUrl: { type: String, default: "" },
        name: { type: String, default: "" },
        size: { type: String, default: null },
        pointer: { type: Boolean, default: false }
    },

    computed: {
        initial() {
            return (this.name || "U").charAt(0).toUpperCase();
        },
        textSizeClass() {
            const sizes = { xlarge: "text-2xl", large: "text-lg" };
            return sizes[this.size] || "text-sm";
        }
    }
};
</script>
